import { parseDomain } from '@wix/domains-serverless-interface';
import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import { createApiClient, createQueriesConfig, QueryConfigTypes } from '@wix/premium-fed-sdk/@apis-infra-react';
const apiConfig = createQueriesConfig({
  tldPromotionsWithPrice: {
    queryFn: async _ref => {
      let {
        httpClient,
        request: {
          limit,
          experimentIds
        }
      } = _ref;
      const {
        listTldPromotions,
        listDisplayPrices
      } = DomainsApiClient.queries({
        httpClient
      });
      const {
        tldPromotions
      } = await listTldPromotions({
        limit
      });
      if (!(tldPromotions != null && tldPromotions.length)) {
        return {
          tldPromotionsWithPrice: []
        };
      }
      try {
        var _displayPrices$filter;
        const {
          displayPrices
        } = await listDisplayPrices({
          domains: (tldPromotions == null ? void 0 : tldPromotions.flatMap(_ref2 => {
            let {
              tld
            } = _ref2;
            return typeof tld === 'string' ? [{
              domain: `example.${tld}`,
              premium: false
            }] : [];
          })) ?? [],
          ...(experimentIds != null && experimentIds.length ? {
            experiments: {
              ids: experimentIds
            }
          } : {})
        }, {
          useErrorBoundary: false
        });
        const displayPriceMap = Object.fromEntries((displayPrices == null || (_displayPrices$filter = displayPrices.filter(price => Boolean(price.domain))) == null ? void 0 : _displayPrices$filter.map(price => [parseDomain(price.domain ?? '').tld, price])) ?? []);
        const tldPromotionsWithPrice = (tldPromotions == null ? void 0 : tldPromotions.map(promotion => ({
          ...promotion,
          pricing: displayPriceMap[promotion.tld ?? ''] ?? {}
        }))) ?? [];
        return {
          tldPromotionsWithPrice
        };
      } catch (e) {
        return {
          tldPromotionsWithPrice: tldPromotions
        };
      }
    },
    queryConfigType: QueryConfigTypes.STATIC_DATA
  }
});
export const tldPromotionsApiClient = createApiClient(apiConfig);
//# sourceMappingURL=TldPromotionsWithPrice.apiClient.js.map